'use client';
 
import { SpeedInsights } from '@vercel/speed-insights/react';
import { useLocation } from 'react-router-dom';
 
export function Insights() {
  const router = useLocation();
 
  return <SpeedInsights route={router.pathname} />;
} 